// Educabolivia/src/components/instructorRegisterForm.js
import React, { useState, useContext } from 'react';
import { AuthContext } from './AuthContext';
import { getStorage, setStorage } from '../utilities/storage';
import usersData from '../mock/users'; // Importar los usuarios existentes

const InstructorRegisterForm = ({ onRegisterSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    bio: ''
  });
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    if (usersData.some(user => user.email === formData.email)) {
      setError('Este email ya está registrado.');
      return;
    }

    // Simular registro de nuevo instructor
    const newInstructor = {
      id: Date.now(),
      username: `${formData.firstName.toLowerCase()}.${formData.lastName.toLowerCase()}`,
      email: formData.email,
      password_hash: formData.password, 
      first_name: formData.firstName,
      last_name: formData.lastName,
      profile_picture: 'https://randomuser.me/api/portraits/men/33.jpg', // Imagen por defecto
      bio: formData.bio,
      role: 'instructor',
      courses: [], // Cursos que creará
      enrolled: [] // Cursos en los que se ha inscrito como estudiante
    };

    // Actualizar el mock de usuarios y localStorage
    const updatedUsers = [...usersData, newInstructor];
  
    usersData.push(newInstructor); // Actualizar el array importado
    setStorage('users', updatedUsers); // Guardar en localStorage 

    // Iniciar sesión automáticamente con el nuevo instructor
    login(newInstructor.email);
    onRegisterSuccess();
  };

  return (
    <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-md mt-10">
      <h2 className="text-3xl font-bold mb-6 text-center text-purple-600">Regístrate como Instructor</h2>
      <p className="text-center text-gray-600 mb-8">
        Únete a nuestra comunidad de instructores y comparte tu conocimiento con el mundo.
      </p>

      {error && <p className="text-red-500 mb-4 text-center">{error}</p>}

      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-gray-700 mb-2">Nombre*</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-purple-600"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Apellido*</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-purple-600"
              required
            />
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Email*</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-purple-600"
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-gray-700 mb-2">Contraseña*</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-purple-600"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Confirmar Contraseña*</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-purple-600"
              required
            />
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Cuéntanos sobre ti (Bio)</label>
          <textarea
            name="bio"
            value={formData.bio}
            onChange={handleChange}
            rows="4"
            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-purple-600"
            placeholder="Ej: Desarrollador Full Stack con 10 años de experiencia en React y Node.js..."
          ></textarea>
        </div>

        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-6 py-2 border border-gray-300 rounded hover:bg-gray-100"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="px-6 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
          >
            Registrarme
          </button>
        </div>
      </form>
    </div>
  );
};

export default InstructorRegisterForm;